import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Input } from '../../../common/html/input'
import { removeSpecials } from '../../../helper'
import {
  clearValidateNameCreatePortfolio,
  selectTextValidateNamePortfolio,
} from '../store/slice/slice'
import { changeFragment } from '../store/slice/sliceComponent'
import { postCreatePortfolio } from '../store/thunk'

export const CreatePortfolio = ({
  isShow,
  setShow,
  isChangeFragment,
  handleAfterCreate,
}) => {
  const dispatch = useDispatch()

  const textValidate = useSelector(selectTextValidateNamePortfolio)

  const [value, setValue] = useState('')

  const handleCreateNewPortfolio = () => {
    dispatch(
      postCreatePortfolio({
        portfolioName: value.trim(),
      }),
    )
      .unwrap()
      .then(() => {
        setShow(false)
        isChangeFragment && dispatch(changeFragment())
        handleAfterCreate && handleAfterCreate()
      })
      .catch(() => {})
  }

  const handleChangeInput = (value) => {
    setValue(removeSpecials(value))
  }

  useEffect(() => {
    if (textValidate) {
      dispatch(clearValidateNameCreatePortfolio())
    }
  }, [value])

  return (
    <>
      {isShow && (
        <PopupAction
          appendStyle={{
            padding: '20px',
            backgroundColor: '#F3F3F3',
            width: 480,
            borderRadius: '4px',
          }}
          isShow={isShow}
          title="library.savePortfolio.CREATE_NEW_PORTFOLIO"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.main.CREATE',
            isI18n: true,
            event: () => {
              handleCreateNewPortfolio()
            },
            disabled: !value.trim(),
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: () => {
              setShow(false)
            },
            isI18n: true,
          }}
        >
          <Input
            placeHolder="library.savePortfolio.ENTER_NAME_PORTFOLIO"
            onChange={(value) => handleChangeInput(value)}
            onEnter={() => {
              handleCreateNewPortfolio()
            }}
            isRemoveSpecialCharacters={true}
            value={value}
          />
          {textValidate && (
            <>
              <Element
                elementName="p"
                style={{
                  fontStyle: 'italic',
                  color: '#E0505B',
                  paddingTop: 4,
                }}
              >
                {textValidate}
              </Element>
            </>
          )}
        </PopupAction>
      )}
    </>
  )
}

CreatePortfolio.propTypes = {
  isChangeFragment: PropTypes.bool,
  handleAfterCreate: PropTypes.func,
}
CreatePortfolio.defaultProps = {
  isChangeFragment: true,
  handleAfterCreate: () => {},
}
